<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
 

      <div class="page-wrapper">

          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">Master Freight</h4>
                    <button v-if="permision_role.method_create" class="btn btn-primary float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="createData()">
                      <i class="link-icon mdi mdi-plus"></i>
                      {{ $t("createNew") }}
                    </button>
  
                    <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="downloadData()">
                      <i class="link-icon mdi mdi-download"></i>
                      {{ $t("downloadData") }} .xlsx
                    </button>
  
                    <button v-if="permision_role.method_upload" class="btn btn-warning float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="uploadData()">
                      <i class="link-icon mdi mdi-upload"></i>
                      {{ $t("UploadTxt") }}
                    </button>

                  
  
                  </div>
  
                  <div class="card-body">
                    <vue-good-table title="list-exim-ceisa-client-login" ref="list-exim-ceisa-client-login"
                      mode="remote" @on-page-change="onPageChange"
                      @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" 
                     
                      @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                      :isLoading.sync="isLoading" :pagination-options="{
                       
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }" :rows="rows" :columns="columns">
   
                   
  
                      <template slot="table-row" slot-scope="props">
                        
                            <span v-if="props.column.field == 'actions'">
                            <a href="#" v-if="permision_role.method_read" title="Detail" @click.prevent="
                                detailData(props.index, props.row)
                                ">
                                <i class="mdi mdi-eye" style="font-size:16px;color:#32a852;"></i>
    
                            </a>
                            <a href="#" v-if="permision_role.method_update" title="Edit"
                                @click.prevent="editData(props.index, props.row)">
                                <i class="mdi mdi-square-edit-outline" style="font-size:16px;color:#9ca832;"></i>
    
                            </a>
                            <a href="#" v-if="permision_role.method_delete" title="Delete"
                                @click.prevent="deleteData(props.index, props.row)">
                                <i class="mdi mdi-delete-forever" style="font-size:16px;color:#a13a3d;"></i>
    
                            </a>
     
                            
                            </span>
     
    
                            <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                            </span>
                            
                      </template>
                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
   

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>


    <modal-add-MasterFreight :showModal="showModalAddMasterFreight" :data="this.forms" @closeModal="closeMyModal"></modal-add-MasterFreight>
    <modal-edit-MasterFreight :showModal="showModalEditMasterFreight" :data="this.forms" @closeModal="closeMyModal"></modal-edit-MasterFreight>
    <modal-detail-MasterFreight :showModal="showModalDetailMasterFreight" :data="this.forms" @closeModal="closeMyModal"></modal-detail-MasterFreight>
 


  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import modalAddMasterFreight from "@/components/exim/billing/master_freight/modal/modalAddMasterFreight.vue";
import modalEditMasterFreight from "@/components/exim/billing/master_freight/modal/modalEditMasterFreight.vue";
import modalDetailMasterFreight from "@/components/exim/billing/master_freight/modal/modalDetailMasterFreight.vue";
 

export default {
    name: "EximMasterFreightIndex",
    props: {},
    components: {

        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        "modal-add-MasterFreight": modalAddMasterFreight,
        "modal-edit-MasterFreight": modalEditMasterFreight,
        "modal-detail-MasterFreight": modalDetailMasterFreight

    },
    data() {

        return {
 
            showModalAddMasterFreight: false,
            showModalEditMasterFreight: false,
            showModalDetailMasterFreight: false,
  
            permision_role: [],
            isLoading: false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            userData: "",
            userRole: "",
            companyCode: "", 
            forms: {master_fr_id:"", product_id:"", product_name:"",category_in:"",category_dn:"", create_by:"", update_by:"" , created_at:"", updated_at:""},
            serverParams: {
            columnFilters: {},
            sort: {
                field: "",
                type: "",
            },
            page: 1,
            per_page: 10,
            },
       
            columns: [
    
                {
                    label: "ID",
                    field: "master_fr_id",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: this.$t("product_code"),
                    field: "product_id",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: this.$t("product_Desc"),
                    field: "product_name",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: "Product Alias",
                    field: "product_alias",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: "Category IN",
                    field: "category_in",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: "Category DN",
                    field: "category_dn",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                    }
                },
            ],
            rows: [],
            rowsSelection: [],
            totalRecords: 0,
        };
    },
    watch: {},
    methods: {

        closeMyModal() {
            this.errors                     = [];
            this.showModalAddMasterFreight  = false;
            this.showModalEditMasterFreight = false;
            this.showModalDetailMasterFreight= false,
            this.forms                      = {master_fr_id:"", product_id:"", product_name:"",product_alias:"",category_in:"",category_dn:"",  create_by:"", update_by:"" , created_at:"", updated_at:""};             
            this.$nextTick(() => {
                this.loadItems();
            });
        },

        uploadData() { 
            window.location.href = "/billing/exim/master-freight/upload";
        },

        createData() {
            this.errors                     = [];
            this.forms                      = {master_fr_id:"", product_id:"", product_name:"",product_alias:"", category_in:"",category_dn:"", create_by:"", update_by:"" , created_at:"", updated_at:""};   
            this.showModalAddMasterFreight  = true;
        },
 
        detailData(index, row) {
    
            this.errors                         = [];
            this.forms                          = row;   
            this.showModalDetailMasterFreight   = true;

        },

        deleteData(index, row) {
        this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourDataDelete"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
        }).then((result) => {
            if (result.value) {
        
                const baseURI =
                    this.$settings.endPointBlujay + "api/new-dashboard/exim/master-freight/delete/" + row.master_fr_id;
                this.$http
                .delete(baseURI)
                .then((response) => {
                    this.loading();
                
                    this.success(response.data.datas.messages);
                    this.loadItems();

                })
                .catch((error) => {
                this.loading();
                if (error.response) {
                    if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                    } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                    } else {
                    this.$router.push("/page-not-found");
                    }
                }
                });
            }
        });
        },

        downloadData() {
            const baseURI = this.$settings.endPointBlujay + "api/new-dashboard/exim/master-freight/index";
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";
            this.isLoading = true; 


            return this.$http.get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&master_fr_id=${this.serverParams.columnFilters.master_fr_id}&product_id=${this.serverParams.columnFilters.product_id}&product_name=${this.serverParams.columnFilters.product_name}&product_alias=${this.serverParams.columnFilters.product_alias}&category_in=${this.serverParams.columnFilters.category_in}&category_dn=${this.serverParams.columnFilters.category_dn}&download=download`,
    
                {
                responseType: "blob",
                }
            )
            .then((response) => {
    
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.isLoading = false;
                
            }).catch((error) => {

                this.isLoading = false;
  
                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));
  
                } else {
  
  
                  if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
  
                  } else {
  
                    if (error.response) {
                      if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                      } else if (error.response.status === 401) {
                        this.logout();
                      } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                      } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                      } else {
                        this.$router.push('/page-not-found');
                      }
                    }
  
                  }
  
                }
            });

        },

        loadItems() {

            const baseURI = this.$settings.endPointBlujay + "api/new-dashboard/exim/master-freight/index";
            this.isLoading = true; 

            return this.$http.get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&master_fr_id=${this.serverParams.columnFilters.master_fr_id}&product_id=${this.serverParams.columnFilters.product_id}&product_name=${this.serverParams.columnFilters.product_name}&product_alias=${this.serverParams.columnFilters.product_alias}&category_in=${this.serverParams.columnFilters.category_in}&category_dn=${this.serverParams.columnFilters.category_dn}`,
                { timeout: 10000 })
                .then((response) => {

                    this.isLoading      = false;
                    this.rows           = response.data.datas.data;
                    this.totalRecords   = response.data.datas.total;

                 }).catch((error) => {
                    
                    this.isLoading      = false;
    
                if (error.code == "ECONNABORTED") {
                    
                    this.error(this.$t("check_internet_connection_txt"));
    
                }else{
    
                    if (error.response) {
                        if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                        this.logout();
                        } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                        } else {
                        this.$router.push('/page-not-found');
                        }
                    }
    
                }
            });
        },

  
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },
  
        onColumnFilter(params) {
            this.updateParams(params);
        },
    
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },
    
        onSortChange(params) {
            this.updateParams({
            sort: {
                type: params[0].type,
                field: params[0].field,
            },
            });
        },
  
        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },
    

        editData(index, row) {

            this.errors                         = [];
            this.forms                          = row;   
            this.showModalEditMasterFreight     = true;

        },
   

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.userData = userDatas.sub;
            this.userRole = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'EximMasterFreightController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;

        },

        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },


        cek_message(status,msg){
            if(status=='200'){
                this.success(msg);
            }
        },

    },
    events: {},
    created: function () { },
    mounted() {

        this.fetchIt();

    },
};
</script>
<style scoped>.required:after {
  content: " *";
  color: red;
}</style>